import { render, staticRenderFns } from "./listItems.vue?vue&type=template&id=3f164889&scoped=true&"
import script from "./listItems.vue?vue&type=script&lang=js&"
export * from "./listItems.vue?vue&type=script&lang=js&"
import style0 from "./listItems.vue?vue&type=style&index=0&id=3f164889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f164889",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VSimpleTable,VToolbar})
